/**
 * Ventura Commercial Painting Schema
 * Enhanced LocalBusiness schema for commercial painting in Ventura
 */

export function getVenturaCommercialSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "HousePainter",
    "name": "Danis Painting Co. - Ventura Commercial Painting",
    "description": "Premier commercial painting contractor serving Ventura businesses: Downtown Main Street, Ventura Harbor, Pacific View Mall, office buildings. Expert retail, restaurant, and hotel painting.",
    "url": "https://danispainting.net/service/commercial-painting/ventura",
    "telephone": "+1-805-403-8727",
    "email": "danispainting@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "133 E De La Guerra St, #267",
      "addressLocality": "Santa Barbara",
      "addressRegion": "CA",
      "postalCode": "93101",
      "addressCountry": "US"
    },
    "geo": [
      {
        "@type": "GeoCoordinates",
        "latitude": 34.2746,
        "longitude": -119.2935,
        "name": "Downtown Ventura - Main Street"
      },
      {
        "@type": "GeoCoordinates",
        "latitude": 34.2478,
        "longitude": -119.2625,
        "name": "Ventura Harbor Village"
      },
      {
        "@type": "GeoCoordinates",
        "latitude": 34.2682,
        "longitude": -119.2292,
        "name": "Pacific View Mall"
      }
    ],
    "areaServed": {
      "@type": "City",
      "name": "Ventura",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "California"
      }
    },
    "serviceType": "Commercial Painting",
    "priceRange": "$$-$$$",
    "paymentAccepted": "Cash, Check, Credit Card, Financing Available",
    "openingHours": "Mo-Su 07:00-19:00",
    "image": "https://d2xsxph8kpxj0f.cloudfront.net/310519663313033271/eUvaV5v4nLRJmrJ6AKc5ww/hero-bg_5849f6b9_e05061fa.webp",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Ventura Commercial Painting Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Downtown Main Street Business Painting",
            "description": "Commercial painting for Main Street retail stores, restaurants, and professional offices"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Ventura Harbor Restaurant & Shop Painting",
            "description": "Harbor Village restaurant and retail painting with coastal-resistant coatings"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pacific View Mall Retail Painting",
            "description": "Shopping center and retail store painting for Pacific View Mall businesses"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Harbor Boulevard Hotel Painting",
            "description": "Hotel and hospitality painting for Harbor Boulevard properties"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Robert K."
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "reviewBody": "Danis Painting transformed our Main Street restaurant. They worked nights and weekends to avoid disrupting our business. Professional crew that understands downtown Ventura's high standards."
      }
    ]
  };
}
